
        var result = require("!!../../../node_modules/css-loader/index.js!./club.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./src/app/club/club.component.css
// module id = 424
// module chunks = 2